import MovideskService from "./MovideskService";
import NeoassistService from "./NeoassistService";

export const TicketService = {

  ObtemSolicitacoes: async (useNeoassist : boolean) => {
    const response = useNeoassist 
      ? await NeoassistService.obterListaDeSolicitacao()
      : await MovideskService.obterListaDeSolicitacao();
    return response.content.solicitacoes;
    // .map(item => ({
    //   id: item.id,
    //   titulo: useNeoassist ? item.titulo : item.subject,
    //   status: item.status
    // }));
  },

  ObtemSolicitantes: async (useNeoassist : boolean, input: string) => {
    const response = useNeoassist 
      ? NeoassistService.obterListaDeSolicitantes(input)
      : MovideskService.obterListaDeSolicitantes(input);
    return response;
  },

  CriarSolicitacao: async (useNeoassist : boolean, input: any) => {
    const response = useNeoassist 
      ? NeoassistService.criarSolicitacao(input)
      : MovideskService.criarSolicitacao(input);
    return response;
  },

  SincronizaSolicitacao: async (useNeoassist : boolean) => {
    const response = useNeoassist 
      ? NeoassistService.sincronizar()
      : MovideskService.sincronizar();
    return response;
  }


};